// src/lib/analytics.js
// ─────────────────────────────────────────────────────────────
// Google Analytics 4 event helpers
// ─────────────────────────────────────────────────────────────

function gtag(...args) {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag(...args);
  }
}

// Uživatel začal vyplňovat formulář (první interakce)
export function trackFormStart() {
  gtag('event', 'form_start', {
    event_category: 'Prihláška',
    event_label: 'Founder Stipendium 2026',
  });
}

// Uživatel dokončil sekci a přešel dál
export function trackSectionComplete(sectionNum, sectionLabel) {
  gtag('event', 'section_complete', {
    event_category: 'Prihláška',
    event_label: sectionLabel,
    value: sectionNum,
  });
}

// Uživatel se vrátil na předchozí sekci
export function trackSectionBack(sectionNum) {
  gtag('event', 'section_back', {
    event_category: 'Prihláška',
    value: sectionNum,
  });
}

// Uživatel nahrál soubor
export function trackFileUpload(fieldKey) {
  gtag('event', 'file_upload', {
    event_category: 'Prihláška',
    event_label: fieldKey,
  });
}

// Validační chyba při přechodu na další sekci
export function trackValidationError(sectionNum, errorKeys) {
  gtag('event', 'validation_error', {
    event_category: 'Prihláška',
    event_label: errorKeys.join(', '),
    value: sectionNum,
  });
}

// Uživatel klikl Odeslat
export function trackSubmitAttempt() {
  gtag('event', 'submit_attempt', {
    event_category: 'Prihláška',
    event_label: 'Founder Stipendium 2026',
  });
}

// Přihláška úspěšně odeslána
export function trackSubmitSuccess() {
  gtag('event', 'submit_success', {
    event_category: 'Prihláška',
    event_label: 'Founder Stipendium 2026',
  });
}

// Chyba při odeslání
export function trackSubmitError(errorMessage) {
  gtag('event', 'submit_error', {
    event_category: 'Prihláška',
    event_label: errorMessage,
  });
}
